import React from 'react'
import PropTypes from 'prop-types'
import FrequentQuestions from "../components/FrequentQuestions";

export const JobseekersPageTemplate = ({ title, frequentQuestions, html }) => {
  return (
    <main id="main" className="site-main">
      <div
        className="jobseekers-content"
        dangerouslySetInnerHTML={{ __html: html }}
      />
      <div className="hero hero-subpage strong-overlay">
        <div className="hero-content text-center">
          <div className="container container-650">
            <h1 className="h-80 weight-bold weight-light">{title}</h1>
          </div>
        </div>

        <section className="section-steps">
          <div className="container container-650">
            <div className="steps">
              <div className="step">
                <div className="circle step-thumb">
                  <p className="h-72 p-purple weight-light">1</p>
                </div>
                <div className="step-info">
                  <h2 className="p-24 weight-bold p-purple">Create a Profile</h2>
                  <p className="p-18 p-gray">Join at <a href="https://jobs.swissmonkey.io/register">https://jobs.swissmonkey.io/register</a> or download the free Swiss Monkey app directly to your phone and create your own unique profile. Dental-specific fields make it easy and fast to create a profile from your mobile device.  If you’re open to temping, include specific days or times!</p>
                </div>
              </div>

              <div className="step">
                <div className="circle step-thumb">
                  <p className="h-72 p-purple weight-light">2</p>
                </div>
                <div className="step-info">
                  <h2 className="p-24 weight-bold p-purple">Receive Job Notifications and Messages</h2>
                  <p className="p-18 p-gray">Job openings are sent in real-time directly to your phone so you can review and apply no matter where you are! Just press a button and submit your profile. Done and done! You can also apply directly to jobs. Doctors may also contact you directly about job opportunities so be sure your profile is up to date.</p>
                </div>
              </div>

              <div className="step">
                <div className="circle step-thumb">
                  <p className="h-72 p-purple weight-light">3</p>
                </div>
                <div className="step-info">
                  <h2 className="p-24 weight-bold p-purple">Interview and Hire</h2>
                  <p className="p-18 p-gray">You’re in control of when and where you want to work. You contract directly with employers so no additional fees are necessary if they want to hire you!</p>
                </div>
              </div>
              <div className="text-center mt-70">
                <a href="https://itunes.apple.com/us/app/swiss-monkey/id1089425152?mt=8" className="btn-main btn-alt">Download the app</a>
              </div>
            </div>
          </div>
        </section>
      </div>

      <FrequentQuestions data={frequentQuestions} />
    </main>
  )
}

JobseekersPageTemplate.propTypes = {
  title: PropTypes.string.isRequired
}

const JobseekersPage = ({ data }) => {
  const { frontmatter, html } = data.markdownRemark;

  return (
    <JobseekersPageTemplate
      html={html}
      title={frontmatter.title}
      frequentQuestions={frontmatter.frequentQuestions}
    />
  )
}

JobseekersPage.propTypes = {
  data: PropTypes.object.isRequired,
}

export default JobseekersPage

export const jobseekersPageQuery = graphql`
  query JobseekersPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
        frequentQuestions {
          question
          answer
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/jobseekers-page.js